import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectLanguageConstants } from '../../common/components/select-lang/constants/select-lang.consts';
import { RouterConstants } from '../../core/routing/constants/app-paths.constant';
import { LANGUAGE_MAPPINGS } from './../../common/constants/language-mappings.const';
import { LanguageConstants } from './constants/lang.consts';
import { GlobalConstants } from '../../common/constants/global.constant';

@Component({
  selector: 'iposcen-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  languages: string[] = [];
  headerForm: FormGroup;
  help: string;
  isSelected: boolean;
  languageText: string;
  language: string;
  cancel: string;
  selectLanguage: string;
  buttonText: string;
  loginhref: string;
  selectedLanguage: string;
  selectedLangCode: string;
  languageJSON = [] as any;
  browserLanguage: string;
  currentdetailPage: string;
  pageName: number;
  ifGameDemo:boolean = false;
  count = 0;
  isRussian = localStorage.getItem('preferredLanguage') === 'ru';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentdetailPage = this.router.url;
    this.pageName = this.currentdetailPage.lastIndexOf('/');
    this.help = LanguageConstants.HELP;
    this.loginhref = RouterConstants.LOGIN_PAGE_LINK;
    this.languageText = LanguageConstants.LANGUAGE;
    this.language = LanguageConstants.LANGUAGE;
    this.cancel = LanguageConstants.CANCEL;
    this.selectLanguage = LanguageConstants.SELECT_LANGUAGE;
    // For IIT3-1125 Bug - if 'preferredLanguage' is null setting it to en-US
    if(localStorage.getItem('preferredLanguage') === null) {
      this.buttonText = LanguageConstants.SELECTED_LANGUAGE_NAME;
      localStorage.setItem('preferredLanguage', LanguageConstants.SELECT_LANGUAGE_CODE);
      localStorage.setItem('preferredLanguageName', LanguageConstants.SELECTED_LANGUAGE_NAME);
    } else {
      this.buttonText = localStorage.getItem('preferredLanguageName');
    }
    this.languages = LANGUAGE_MAPPINGS.map(lang => lang.langName);
    this.browserLanguage = (LANGUAGE_MAPPINGS.some(lang => lang.langCode === navigator.language)) ? navigator.language : 
    GlobalConstants.LANGUAGE_ENGLISH;

    if (localStorage.getItem('preferredLanguage') !== undefined && localStorage.getItem('preferredLanguage') !== null) {
      this.browserLanguage = localStorage.getItem('preferredLanguage');
      this.selectedLangCode = localStorage.getItem('preferredLanguage');
    } else {
      this.selectedLangCode = LanguageConstants.SELECT_LANGUAGE_CODE;
    }
    if (localStorage.getItem('preferredLanguageName') !== undefined && localStorage.getItem('preferredLanguageName') !== null) {
      this.selectedLanguage = localStorage.getItem('preferredLanguageName');
    } else {
      this.selectedLanguage = LanguageConstants.SELECTED_LANGUAGE_NAME;
    }
    this.loadJSONObject(this.browserLanguage);
    this.headerForm = this.formBuilder.group({
      lang: new FormControl('', [Validators.required])
    });
    if(this.currentdetailPage.substring(this.pageName + 1) === GlobalConstants.GAME_DEMOS || 
        this.currentdetailPage.substring(this.pageName + 1) === GlobalConstants.UNISON_DEMO){
      this.ifGameDemo = true;
    }
  }

  trackByLanguage(index: number, el: string): number {
    return index;
  }

  getButtonText() {
    this.buttonText = this.selectedLanguage;
    if(this.selectedLangCode === 'zh-tw'){
      this.selectedLangCode = 'zh-Hant'
    }else if(this.selectedLangCode === 'zh-cn'){
      this.selectedLangCode = 'zh-Hans'
    }
    localStorage.setItem('preferredLanguage', this.selectedLangCode);
    localStorage.setItem('preferredLanguageName', this.selectedLanguage);
    //gtm(google tag manager)
    window['dataLayer'].push({
      'selectedLanguage': this.buttonText
    });
    let routeLink;
    if(this.currentdetailPage.substring(this.pageName + 1) === GlobalConstants.GAME_DEMOS){
      routeLink= `/${this.selectedLangCode}/game-demos`;
    }else if(this.currentdetailPage.substring(this.pageName + 1) === GlobalConstants.UNISON_DEMO){
      routeLink= `/${this.selectedLangCode}/unison-demo`;
    }
    else{
      routeLink = `/${this.selectedLangCode}/index.html`;
    }
    location.assign(routeLink);
  }

  setButtonText(selectedName: string, selectedCode: string) {
    this.selectedLanguage = selectedName;
    this.selectedLangCode = selectedCode;
  }

  loadJSONObject(defaultLanguage: string): void {
    LANGUAGE_MAPPINGS.forEach(element => {
      let display = false;
      if (defaultLanguage === element.langCode) {
        display = true;
        this.count = 1;
      }
      const language = {
        langCode: element.langCode,
        langName: element.langName,
        langInEng: element.langInEng,
        checked: display
      };
      this.languageJSON.push(language);
    });
      if (this.count === 0) {
        this.router.navigate([RouterConstants.SELECT_LANGUAGE_LINK, SelectLanguageConstants.LOGIN_DEFAULT]);
      }
  }

  cancelSelection() {
    this.selectedLangCode = localStorage.getItem('preferredLanguage');
    window['dataLayer'].push({
      selectedLanguage: this.selectedLangCode
    });
    const routeLink = `/${this.selectedLangCode}/index.html`;
    location.assign(routeLink);
  }

}
